import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
const AdHocChecks = (params) => {
  const history = useHistory();
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Check-In/Check-Out Sheet</h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div class="search-box mt-0">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />{" "}
                            <input type="submit" />
                          </form>
                        </div>{" "}
                      </div>
                      <div class="btns col-sm-7 col-12 align-right px-0 justify-content-end">
                        <button id="" type="Submit">
                          Update Prices
                        </button>
                        <button id="cancel" type="button">
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div
                className="accordion px-0"
                id="accordionPanelsStayOpenExample"
              >
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">Ingredients</h4>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive">
                            <table className="checklist-table menu-pricing table-striped">
                              <thead>
                                <tr>
                                  <th className="col-2">Category</th>
                                  <th className="col-2">Ingredient Name</th>
                                  <th className="col-2">Current Unit Price</th>
                                  <th className="text-right">Current Stock</th>
                                  <th className="text-right">Check-In</th>
                                  <th class="header text-right">Check-Out</th>
                                  <th class="header text-right" width="">
                                    Stock To Remain
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="menu_item_row">
                                  <td>Beer</td>
                                  <td>Corona</td>
                                  <td>
                                    <span>$2.50 per pieces </span>
                                    <br />
                                  </td>
                                  <td className="align-right">49.000 </td>

                                  <td class="count-unit">
                                    <span class="count_enclosure">
                                      <input
                                        name="data[MenuItem][0][PosMenuitemsPrice][471][menu_price_show]"
                                        value="54.00"
                                        class="menu_price number currency"
                                        step="1"
                                        tofixed="2"
                                        min="0"
                                        type="text"
                                        id="MenuItem0PosMenuitemsPrice471MenuPriceShow"
                                      />{" "}
                                      <a
                                        href="#"
                                        class="addReason incDecCount plus_Custome"
                                        dir="inc"
                                      >
                                        <img
                                          src="/img/plus.svg"
                                          height="20"
                                          width="15"
                                          alt=""
                                        />
                                      </a>
                                      <a
                                        href="#"
                                        class="addReason incDecCount minsucustom"
                                        dir="dec"
                                      >
                                        <img src="/img/minus.svg" alt="" />
                                      </a>
                                    </span>
                                  </td>
                                  <td class="count-unit">
                                    <span class="count_enclosure">
                                      <input
                                        name="data[MenuItem][0][PosMenuitemsPrice][471][profit_margin_show]"
                                        value="100.00"
                                        class="profit_margin number number_format"
                                        step="1"
                                        tofixed="2"
                                        min="0"
                                        type="text"
                                        id="MenuItem0PosMenuitemsPrice471ProfitMarginShow"
                                      />
                                      <a
                                        href="#"
                                        class="addReason incDecCount plus_Custome"
                                        dir="inc"
                                      >
                                        <img
                                          src="/img/plus.svg"
                                          height="20"
                                          width="15"
                                          alt=""
                                        />
                                      </a>
                                      <a
                                        href="#"
                                        class="addReason incDecCount minsucustom"
                                        dir="dec"
                                      >
                                        <img src="/img/minus.svg" alt="" />
                                      </a>
                                    </span>
                                  </td>
                                  <td className="align-right">
                                    <span class="stock_to_remain_span">
                                      49.000
                                    </span>{" "}
                                  </td>
                                </tr>

                                <tr class="menu_item_row">
                                  <td>Beer</td>
                                  <td>Corona</td>
                                  <td>
                                    <span>$2.50 per pieces </span>
                                    <br />
                                  </td>
                                  <td className="align-right">49.000 </td>

                                  <td class="count-unit">
                                    <span class="count_enclosure">
                                      <input
                                        name="data[MenuItem][0][PosMenuitemsPrice][471][menu_price_show]"
                                        value="54.00"
                                        class="menu_price number currency"
                                        step="1"
                                        tofixed="2"
                                        min="0"
                                        type="text"
                                        id="MenuItem0PosMenuitemsPrice471MenuPriceShow"
                                      />{" "}
                                      <a
                                        href="#"
                                        class="addReason incDecCount plus_Custome"
                                        dir="inc"
                                      >
                                        <img
                                          src="/img/plus.svg"
                                          height="20"
                                          width="15"
                                          alt=""
                                        />
                                      </a>
                                      <a
                                        href="#"
                                        class="addReason incDecCount minsucustom"
                                        dir="dec"
                                      >
                                        <img src="/img/minus.svg" alt="" />
                                      </a>
                                    </span>
                                  </td>
                                  <td class="count-unit">
                                    <span class="count_enclosure">
                                      <input
                                        name="data[MenuItem][0][PosMenuitemsPrice][471][profit_margin_show]"
                                        value="100.00"
                                        class="profit_margin number number_format"
                                        step="1"
                                        tofixed="2"
                                        min="0"
                                        type="text"
                                        id="MenuItem0PosMenuitemsPrice471ProfitMarginShow"
                                      />
                                      <a
                                        href="#"
                                        class="addReason incDecCount plus_Custome"
                                        dir="inc"
                                      >
                                        <img
                                          src="/img/plus.svg"
                                          height="20"
                                          width="15"
                                          alt=""
                                        />
                                      </a>
                                      <a
                                        href="#"
                                        class="addReason incDecCount minsucustom"
                                        dir="dec"
                                      >
                                        <img src="/img/minus.svg" alt="" />
                                      </a>
                                    </span>
                                  </td>
                                  <td className="align-right">
                                    <span class="stock_to_remain_span">
                                      49.000
                                    </span>{" "}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">
                          Submitted Sheets
                        </h4>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                            <div class="search-box">
                              <form
                                action="/productions"
                                id="MenuItemIndexForm"
                                method="get"
                                accept-charset="utf-8"
                              >
                                {" "}
                                <input
                                  name="keyword"
                                  placeholder="Search"
                                  type="text"
                                  id="MenuItemKeyword"
                                />{" "}
                                <input type="submit" />
                              </form>
                            </div>{" "}
                          </div>
                          <div className="table-responsive">
                            <table className="checklist-table menu-pricing table-striped">
                              <thead>
                                <tr>
                                  <th>Submission Date/Time</th>
                                  <th># of Ingred. In</th>
                                  <th># of Ingred. Out</th>
                                  <th># of Recipes In</th>
                                  <th># of Recipes Out</th>
                                  <th># of Menu Items In</th>
                                  <th># of Menu Items Out</th>
                                  <th className="action-td">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="event-edit-link">
                                    2020/09/17 18:10pm{" "}
                                  </td>
                                  <td>0</td>
                                  <td>0</td>
                                  <td>37</td>
                                  <td>0</td>
                                  <td>0</td>
                                  <td>0</td>
                                  <td>
                                    <div className="d-flex jusitfy-content-end">
                                      <a
                                        class="view_event circle_icon"
                                        href="/productions/check_view/165"
                                      >
                                        <i class="iconSprites eye-icon"> </i>
                                      </a>
                                      <a
                                        class="circle_icon"
                                        href="/promotions/edit/165"
                                      >
                                        <i class="iconSprites print-icon"> </i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default AdHocChecks;
